module.exports = __webpack_public_path__ + "img/Weapon_151.a7043505.png";